import {
  i18n
} from "../../plugins/vue-i18n";

export default class PaymentType {
  constructor(codeName) {
    this.codeName = codeName;
    this.name = i18n.t("CONTENT.payments." + codeName);
  }

  static createFromData(data) {
    return new PaymentType(data.codeName);
  }


}
